import React, { useState, useEffect } from 'react';
import './CountdownTimer.css';

const CountdownTimer = ({ auctionStartTime, auctionEndTime, onAuctionEnd }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [timeStart, setTimeStart] = useState(calculateTimeStart());
  const [started, auctionStarted ] = useState (false)

  useEffect(() => {
    const timerId = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.total <= 0) {
        clearInterval(timerId);
        onAuctionEnd();  // Notify that auction has ended
      }
    }, 1000);
  }, [auctionEndTime, onAuctionEnd]);

    useEffect(() => {
     

      const timerId = setInterval(() => {
        const newTimeStart = calculateTimeStart();

        setTimeStart(newTimeStart);
  
        if (newTimeStart.total <= 0) {
          auctionStarted(true);
          clearInterval(timerId);



          
        }

      }, 1000);

      

      

    return () => clearInterval(timerId); // Cleanup timer on component unmount
  }, [auctionStartTime]);

  

  function calculateTimeLeft() {
    const now = new Date();
    const endTime = new Date(auctionEndTime);
    const difference = endTime - now; 

    let timeLeft = {
      total: difference,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)), // Days left
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24), // Hours left
      minutes: Math.floor((difference / 1000 / 60) % 60), // Minutes left
      seconds: Math.floor((difference / 1000) % 60), // Seconds left
    };

    return timeLeft;
  }

  function calculateTimeStart() {
    const now = new Date();
    const startTime = new Date(auctionStartTime);
    const difference = startTime - now; 

    let timeStart = {
      total: difference,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)), // Days left
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24), // Hours left
      minutes: Math.floor((difference / 1000 / 60) % 60), // Minutes left
      seconds: Math.floor((difference / 1000) % 60), // Seconds left
    };

    return timeStart;
  }

  const formatTime = () => {
    if (timeLeft.total <= 0) {
      return 'Auction ended';
    }

    if (!started) {
      const { days, hours, minutes, seconds } = timeStart;
  
      if (days > 1) {
        return `Auction starts in ${days} days ${hours} hours ${minutes} minutes ${seconds} seconds`;
      }
      
      if (days === 1) {
        return `Auction starts in ${days} day ${hours} hours ${minutes} minutes`;
      }
  
      if (hours > 1) {
        return `Auction starts in ${hours} hours ${minutes} minutes ${seconds} seconds`;
      }
  
      if (hours === 1) {
        return `Auction starts in ${hours} hour ${minutes} minutes`;
      }
  
      if (minutes > 1) {
        return `Auction starts in ${minutes} minutes ${seconds} seconds`;
      }
  
      if (minutes === 1) {
        return `Auction starts in ${minutes} minute ${seconds} seconds`;
      }

      if (seconds > 1) { 

        return `Auction starts in ${seconds} seconds`;

      }
  
      if (seconds === 1) {
        return `Auction starts in ${seconds} second`;
      }
  
    } 

    if (timeLeft.total >= 0){
      return `${timeLeft.hours}h: ${timeLeft.minutes}m: ${timeLeft.seconds}s`;
    }

  };

  return (
    <div className="countdown-timer">
      <h3>{formatTime()}</h3>
    </div>
  );
};

export default CountdownTimer;
